import { useCallback, useEffect } from 'react';
import { useTimePickerData } from './useTimePickerData';
import { useTrackComponentEvent } from './useTrackComponentEvent';
import { TrackingPayload } from '../types';

export const useAnalytics = (
  data: ReturnType<typeof useTimePickerData>,
  timeOptions: any[],
  timepickerTestFlag: boolean,
  trackAvailableTimesFlagEnabled: boolean
) => {
  const { bookingBoatId, bookingDuration, tripStartFormatted } = data;
  const trackComponentEvent = useTrackComponentEvent();

  const trackAvailableTimes = useCallback(() => {
    const payload: TrackingPayload = {
      trip_date: tripStartFormatted,
      duration: bookingDuration?.label,
      boat_public_id: bookingBoatId,
      available_times_grid: Object.fromEntries(timeOptions.map((option) => [option.value, option.available])),
      timepicker_test_flag_enabled: timepickerTestFlag.toString(),
    };

    trackComponentEvent({
      event_name: 'show',
      component_type: 'group_of_controls',
      object: 'booking_widget',
      context: 'booking_widget',
      object_properties: payload,
    });
  }, [bookingBoatId, bookingDuration, timeOptions, tripStartFormatted, timepickerTestFlag, trackComponentEvent]);

  useEffect(() => {
    if (timeOptions.length > 0 && trackAvailableTimesFlagEnabled) {
      trackAvailableTimes();
    }
  }, [timeOptions, trackAvailableTimes, trackAvailableTimesFlagEnabled]);

  return { trackAvailableTimes };
};
